var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 2,
    fill: "white",
    fillOpacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0205 2.20118C17.5268 2.20327 17.9375 2.61475 17.9395 3.1211L17.957 7.64454C17.9587 8.15327 17.5469 8.56447 17.0381 8.56251C16.5319 8.56038 16.1212 8.14981 16.1191 7.64356L16.1104 5.33399L9.6211 11.8232C9.59344 11.8509 9.56358 11.8759 9.53321 11.8994L5.32813 16.1055L7.6377 16.1143C8.14406 16.1163 8.55469 16.5278 8.55665 17.0342C8.55849 17.5429 8.14733 17.9548 7.63868 17.9531L3.11524 17.9356C2.6088 17.9336 2.19728 17.5221 2.19532 17.0156L2.17774 12.4922C2.17591 11.9834 2.58782 11.5713 3.09669 11.5732C3.60312 11.5752 4.01465 11.9867 4.01661 12.4932L4.0254 14.8027L10.5147 8.31348C10.5422 8.28592 10.5713 8.25983 10.6016 8.23634L14.8066 4.03126L12.4971 4.02247C11.9909 4.02026 11.5801 3.60882 11.5781 3.10255C11.5762 2.59359 11.9881 2.18163 12.4971 2.1836L17.0205 2.20118Z",
    fill: "#5A608D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/expand-icon.72c92abd.svg";
export { ForwardRef as ReactComponent };